import { jsxs as m, jsx as o } from "react/jsx-runtime";
import { ChannelCard as p } from "./contact-channels75.js";
import { WhatsAppContent as s } from "./contact-channels34.js";
import { WhatsAppFooter as d } from "./contact-channels35.js";
import { WhatsAppHeader as c } from "./contact-channels33.js";
const A = (i) => {
  const { cardOverrides: t, containerOverrides: e, footerConfig: n, variation: r = "minimal", onClick: a } = i;
  return /* @__PURE__ */ m(
    p,
    {
      cardOverrides: { ...t, onClick: a },
      containerOverrides: e,
      isMinimal: r === "minimal",
      children: [
        /* @__PURE__ */ o(c, { variation: r }),
        /* @__PURE__ */ o(s, { variation: r }),
        /* @__PURE__ */ o(d, { variation: r, ...n })
      ]
    }
  );
};
export {
  A as WhatsApp
};
//# sourceMappingURL=contact-channels32.js.map
